import { render, staticRenderFns } from "./Comissions.vue?vue&type=template&id=1c6079b7&"
import script from "./Comissions.vue?vue&type=script&lang=js&"
export * from "./Comissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports